import React from "react";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import DefaultLogo from "components/SidenavLogo/DefaultLogo";
import {ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import IntlMessages from "appUtil/IntlMessages";
import Helpers from "../../../ts/utils/Helpers";
import DatabaseLogoSettings from "components/DatabaseLogoSettings";
import * as _ from 'lodash';
import QueryString from "query-string";
import {NotificationManager} from "react-notifications";

class DatabaseLogo extends React.Component {

    constructor(props) {
        super(props);
        this.openSettings = this.openSettings.bind(this);
        this.saveSettings = this.saveSettings.bind(this);
        this.optionsExpandedChanged = this.optionsExpandedChanged.bind(this);
        this.onChangedSettings = this.onChangedSettings.bind(this);
        this.refreshDatabase = this.refreshDatabase.bind(this);
        this.goToDatabaseMain = this.goToDatabaseMain.bind(this);
        this.onChangeMetadata = this.onChangeMetadata.bind(this);
        this.state = {
            databaseCatalog: null,
            database: null,
            group: null,
            settings: {},
            optionsExpanded: localStorage.getItem("optionsExpanded") === "1",
        }
    }

    componentDidMount() {
        this.props.databaseEventBus.addListener('changed', this.refreshDatabase);
        this.props.databaseEventBus.addListener('database-group-updated', this.refreshDatabase);
        this.props.settingsEventBus.addListener('optionsExpanded-changed', this.optionsExpandedChanged);
        this.checkDatabaseLogo();
        if (this.state.databaseCatalog && (!this.state.databaseCatalog.settings || !this.state.databaseCatalog.settings['database.logo'])) {
            if (!this.state.databaseCatalog.settings) {
                this.state.databaseCatalog.settings = {};
            }
            if (!this.state.databaseCatalog.settings['database.logo']) {
                this.state.databaseCatalog.settings['database.logo'] = {};
            }
            this.props.registryService.getDatabaseCatalogSettings(this.state.databaseCatalog.id, 'database.logo').then(response => {
                if (response.data) {
                    this.state.databaseCatalog.settings['database.logo'] = response.data;
                    this.setState({settings: response.data});
                }
            });
        } else if (this.state.group) {
            if (!this.state.group.settings) {
                this.state.group.settings = {};
            }
            if (!this.state.group.settings['database.logo']) {
                this.state.group.settings['database.logo'] = {};
            }
            this.props.registryService.getDatabaseCatalogGroupSettings(this.state.group.id, 'database.logo').then(response => {
                if (response.data) {
                    this.state.group.settings['database.logo'] = response.data;
                    this.setState({settings: response.data});
                }
            });
        }
    }

    refreshDatabase() {
        this.setState({...DatabaseLogo.generateState(this.props), nonce: Math.random().toString().substr(2)});
    }

    componentWillUnmount() {
        this.props.databaseEventBus.removeListener('changed', this.refreshDatabase);
        this.props.databaseEventBus.removeListener('database-group-updated', this.refreshDatabase);
        this.props.settingsEventBus.removeListener('optionsExpanded-changed', this.optionsExpandedChanged);
    }

    optionsExpandedChanged() {
        this.setState({
            optionsExpanded: localStorage.getItem("optionsExpanded") === "1"
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.database !== prevState.database) {
            this.checkDatabaseLogo();
        } else if (this.state.database && this.state.database.has_logo && !this.state.database) {
            let database = this.state.database;
            this.props.registryService.getDatabaseLogo(database.id).then(response => {
                database.logo_image = response.data.content;
                database.logo_image_mime_type = response.data.mine_type;
            });
        }
        if (this.state.databaseCatalog && (!this.state.databaseCatalog.settings || !this.state.databaseCatalog.settings['database.logo'])) {
            if (!this.state.databaseCatalog.settings) {
                this.state.databaseCatalog.settings = {};
            }
            if (!this.state.databaseCatalog.settings['database.logo']) {
                this.state.databaseCatalog.settings['database.logo'] = {};
            }
            this.props.registryService.getDatabaseCatalogSettings(this.state.databaseCatalog.id, 'database.logo').then(response => {
                if (response.data) {
                    this.state.databaseCatalog.settings['database.logo'] = response.data;
                    this.setState({settings: response.data});
                }
            });
        } else if (this.state.group && prevState.group !== this.state.group) {
            if (!this.state.group.settings) {
                this.state.group.settings = {};
            }
            if (!this.state.group.settings['database.logo']) {
                this.state.group.settings['database.logo'] = {};
            }
            this.props.registryService.getDatabaseCatalogGroupSettings(this.state.group.id, 'database.logo').then(response => {
                if (response.data) {
                    this.state.group.settings['database.logo'] = response.data;
                    this.setState({settings: response.data});
                }
            });
        }


    }

    checkDatabaseLogo() {
        const database = this.state.database;
        if (database && database.has_logo && !database.logo_image) {
            this.props.registryService.getDatabaseLogo(database.id).then(response => {
                database.logo_image = response.data.content;
                database.logo_image_mime_type = response.data.mime_type;
                this.forceUpdate();
            });
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const databaseId = nextProps.database ? nextProps.database.id : parseInt(nextProps.match.params.id);
        if (prevState.database && prevState.database.id === databaseId) {
            return {};
        }
        return DatabaseLogo.generateState(nextProps);
    }

    static generateState(props) {
        const databaseId = props.database ? props.database.id : parseInt(props.match.params.id);
        let databaseCatalog = null;
        let database = null;
        let group = null;
        if (props.database) {
            databaseCatalog = props.database.catalog;
            database = props.database;
        } else if (Number.isSafeInteger(databaseId)) {
            databaseCatalog = props.databaseList.filter(catalog => catalog.databases.filter(d => d.id === databaseId).length > 0).first;
            database = databaseCatalog ? databaseCatalog.databases.filter(d => d.id === databaseId).first : null;
        } else {
            if (props.match.path === '/app/diagram/database' && props.location.search) {
                const query = QueryString.parse(props.location.search);
                if (typeof (query.groupId) === 'string') {
                    const groupId = parseInt(query.groupId);
                    if (Number.isSafeInteger(groupId)) {
                        group = props.databaseGroups.find(g => g.id === groupId);
                    }
                }
            }
        }
        let settings = {
            visible: {
                groupLogo: true,
                groupTitle: true,
                databaseLogo: false,
                databaseInstitution: false,
                orderElements: ['databaseLogo', 'databaseName', 'databaseInstitution', 'groupLogo', 'groupTitle']
            }
        }
        if (databaseCatalog) {
            if (databaseCatalog.group) {
                group = databaseCatalog.group;
            } else if (databaseCatalog.group_id) {
                group = props.databaseGroups.find(g => g.id === databaseCatalog.group_id);
            }
            if (databaseCatalog.settings && databaseCatalog.settings['database.logo']) {
                settings = databaseCatalog.settings['database.logo'];
            }
        } else if (group) {
            if (group.settings && group.settings['database.logo']) {
                settings = group.settings['database.logo'];
            } else {
                delete settings.visible.databaseLogo;
                delete settings.visible.databaseInstitution;
            }
        }
        return {databaseCatalog, database, group, settings}
    }

    render() {
        const {databaseCatalog, optionsExpanded, group} = this.state;
        if (!databaseCatalog && !group) {
            return (
                <div>
                    <DefaultLogo/>
                    <i className="pointer fas fa-cog mx-start-1" onClick={this.openSettings}/>
                </div>
            )
        } else {
            return (
                <div className="d-flex align-items-center header-logo-group">
                    {this.renderLogo()}
                    {optionsExpanded && <i className="pointer fas fa-cog mx-start-1" onClick={this.openSettings}/>}
                </div>
            )
        }
    }

    openSettings() {
        this.settingsDataTmp = Helpers.deepCopy(this.state.settings);
        const {group, database} = this.state;
        const metaData = {};

        if (!this.settingsDataTmp.orderElements) {
            this.settingsDataTmp.orderElements = ['databaseLogo', 'databaseName', 'databaseInstitution'];
        }
        if (!this.settingsDataTmp.orderElements.includes('databaseName')) {
            this.settingsDataTmp.orderElements.push('databaseName');
        }
        if (!this.settingsDataTmp.orderElements.includes('groupLogo')) {
            this.settingsDataTmp.orderElements.push('groupLogo');
        }
        if (!this.settingsDataTmp.orderElements.includes('groupTitle')) {
            this.settingsDataTmp.orderElements.push('groupTitle');
        }
        if (!this.settingsDataTmp.visible) {
            this.settingsDataTmp.visible = {
                groupLogo: true,
                groupTitle: true,
                databaseLogo: false,
                databaseName: true,
                databaseInstitution: false,
            }
        }
        if (this.settingsDataTmp.visible.databaseName == null) {
            this.settingsDataTmp.visible.databaseName = false;
        }
        if (group) {
            metaData.groupLogoUrl = group.has_logo ? `database/group/${group.id}/logo` : '';
            metaData.groupName = group.name;
        } else {
            this.settingsDataTmp.orderElements.splice(this.settingsDataTmp.orderElements.indexOf('groupLogo'), 1);
            this.settingsDataTmp.orderElements.splice(this.settingsDataTmp.orderElements.indexOf('groupTitle'), 1);
        }
        if (database) {
            metaData.databaseLogoUrl = database.has_logo ? `data:${database.logo_image_mime_type};base64,${database.logo_image}` : '';
            metaData.databaseInstitution = database.institution || '';
            metaData.databaseName = database.catalog.name;
        } else {
            if (this.settingsDataTmp.orderElements.indexOf('databaseLogo') !== -1) {
                this.settingsDataTmp.orderElements.splice(this.settingsDataTmp.orderElements.indexOf('databaseLogo'), 1);
            }
            if (this.settingsDataTmp.orderElements.indexOf('databaseInstitution') !== -1) {
                this.settingsDataTmp.orderElements.splice(this.settingsDataTmp.orderElements.indexOf('databaseInstitution'), 1);
            }
            if (this.settingsDataTmp.orderElements.indexOf('databaseName') !== -1) {
                this.settingsDataTmp.orderElements.splice(this.settingsDataTmp.orderElements.indexOf('databaseName'), 1);
            }
        }
        this.props.modalService.show(
            <ModalHeader toggle={this.props.modalService.close}>
                <IntlMessages id="settings"/>
                <div className="layer-actions">
                    <button className="system-button size-s mx-start-auto" onClick={this.saveSettings}>
                        <IntlMessages id="common.ok"/>
                    </button>
                </div>
            </ModalHeader>,
            <ModalBody>
                <DatabaseLogoSettings data={this.settingsDataTmp} onChange={this.onChangedSettings} metaData={metaData}
                                      onChangeMetadata={this.onChangeMetadata}/>
            </ModalBody>, <ModalFooter></ModalFooter>, "database-logo-settings", false, 'drawer', {
                width: '25vw',
                sizable: true
            });
    }

    onChangeMetadata(metadata) {
        this.tmpMetadata = metadata;
    }

    saveSettings() {
        //this.props.modalService.close();
        let settings = _.merge(this.state.settings, this.settingsDataTmp);
        const all = [];
        const {database, databaseCatalog, group} = this.state;
        if (this.tmpMetadata) {
            let groupChanged = {};
            if (this.tmpMetadata.groupName !== group.name) {
                groupChanged.name = this.tmpMetadata.groupName;
            }
            if (!this.tmpMetadata.groupLogoUrl && group.has_logo) {
                groupChanged.logo = null;
            } else if (this.tmpMetadata.groupLogoUrl && this.tmpMetadata.groupLogoUrl.startsWith('data:image')) {
                groupChanged.logo = {
                    url: this.tmpMetadata.groupLogoUrl,
                    filename: this.tmpMetadata.groupLogoUrlFilename,
                    type: this.tmpMetadata.groupLogoUrlMimetype,
                }
            }
            if (Object.keys(groupChanged).length) {
                groupChanged = {...group, ...groupChanged};
                all.push(this.props.registryService.modifyDatabaseGroup(groupChanged).then((response) => {
                    const index = this.props.databaseGroups.indexOf(this.props.databaseGroups.find(g => g.id === response.data.id));
                    this.props.databaseGroups[index] = response.data;
                    this.props.databaseEventBus.emit('database-group-updated');
                }).catch(reason => {
                    NotificationManager.error(Helpers.getMessageException(reason), <IntlMessages
                        id="database.group"/>);
                }));
            }
            let databaseChanged = {};
            if (!this.tmpMetadata.databaseLogoUrl && database.has_logo) {
                databaseChanged.logo = null;
            } else if (this.tmpMetadata.databaseLogoUrl && this.tmpMetadata.databaseLogoUrl.startsWith('data:image')) {
                if (`data:${database.logo_image_mime_type};base64,${database.logo_image}` !== this.tmpMetadata.databaseLogoUrl) {
                    databaseChanged.logo = {
                        url: this.tmpMetadata.databaseLogoUrl,
                        filename: this.tmpMetadata.databaseLogoUrlFilename,
                        type: this.tmpMetadata.databaseLogoUrlMimetype,
                    }
                }
            }
            if (this.tmpMetadata.databaseInstitution !== (database.institution || '')) {
                databaseChanged.institution = this.tmpMetadata.databaseInstitution;
            }
            if (Object.prototype.hasOwnProperty.call(databaseChanged, 'logo')) {
                all.push(this.props.registryService.updateDatabaseLogo(database.id, databaseChanged.logo).then((response) => {
                    if (databaseChanged.logo) {
                        database.logo_image = databaseChanged.logo.url.split(',')[1];
                        database.logo_image_mime_type = databaseChanged.logo.type;
                    } else {
                        database.logo_image = null;
                        database.logo_image_mime_type = null;
                    }
                    this.props.databaseEventBus.emit('changed');
                }).catch(reason => {
                    NotificationManager.error(Helpers.getMessageException(reason), <IntlMessages
                        id="database"/>);
                }));
            }
            if (Object.prototype.hasOwnProperty.call(databaseChanged, 'institution')) {
                all.push(this.props.registryService.updateDatabase(database.id, {institution: databaseChanged.institution}).then((response) => {
                    database.institution = databaseChanged.institution;
                    this.props.databaseEventBus.emit('changed');
                }).catch(reason => {
                    NotificationManager.error(Helpers.getMessageException(reason), <IntlMessages
                        id="database"/>);
                }));
            }
        }
        if (databaseCatalog) {
            if (!databaseCatalog.settings) {
                databaseCatalog.settings = {};
            }
            databaseCatalog.settings['database.logo'] = settings;
            all.push(this.props.registryService.saveDatabaseCatalogSettings(databaseCatalog.id, 'database.logo', settings).then(() => {
            }));
        } else if (group) {
            if (!group.settings) {
                group.settings = {};
            }
            group.settings['database.logo'] = settings;
            all.push(this.props.registryService.saveDatabaseCatalogGroupSettings(group.id, 'database.logo', settings).then(() => {
            }));
        }
        Promise.all(all).then(() => {
            this.props.modalService.close();
            this.setState({settings});
        })
    }

    onChangedSettings(data) {
        this.settingsDataTmp = data;
    }

    renderLogo() {
        const {databaseCatalog, database, group, settings, nonce} = this.state;
        if (settings.visible && settings.orderElements) {
            let elements = [];
            const groupedElements = [];
            for (const elementKey of settings.orderElements) {
                if (settings.visible[elementKey]) {
                    if (elementKey === 'groupLogo') {
                        if (group && group.has_logo) {
                            elements.push(<span key="groupLogo" onClick={this.goToDatabaseMain}
                                                className="db-image">
                                    <img src={`database/group/${group.id}/logo?${nonce ? ('nonce=' + nonce) : ''}`}
                                         alt={""}/>
                                </span>);
                        }
                    } else if (elementKey === 'groupTitle') {
                        if (group) {
                            groupedElements.push(<span key="groupTitle" className="db-group-name">
                                <IntlMessages id={`dbGroup.${group.id}.name`} defaultMessage={group.name}/></span>);
                        }
                    } else if (elementKey === 'databaseLogo') {
                        elements.push(this.renderDatabaseLogo());
                    } else if (elementKey === 'databaseName') {
                        elements.push(this.renderDatabaseName());
                    } else if (elementKey === 'databaseInstitution') {
                        if (database && database.institution) {
                            groupedElements.push(<span key={'databaseInstitution'}
                                                       className="db-group-name">{`${database.institution}`}</span>);
                        }
                    }

                }
            }
            if (groupedElements.length > 0) {
                elements.push(<span className="grouped-items" key="groupedElement">{groupedElements}</span>);
            }
            if (elements.length === 0) {
                return (
                    <DefaultLogo/>
                );
            }
            return (
                <div>
                    {elements}
                </div>
            )
        }
        if (database && database.has_logo) {
            return this.renderDatabaseLogo();
        } else {
            if (group && group.has_logo) {
                return (
                    <span className={"pointer d-flex align-items-center"}
                          onClick={this.goToDatabaseMain}>
                                <span className="db-image">
                                    <img src={`database/group/${group.id}/logo?${nonce ? ('nonce=' + nonce) : ''}`}
                                         alt={""}/>
                                </span>
                        {database && database.name && <span className="db-name">{`${database.name}`}</span>}
                        {(!database || !database.name) &&
                            <span className="db-group-name mx-start-3">{`${group.name}`}</span>}
                            </span>
                )
            }
            if (database) {
                if (database.name) {
                    return (
                        <span onClick={this.goToDatabaseMain}
                              className="pointer db-name">{`${database.name}`}</span>
                    )
                } else {
                    return (
                        <span onClick={this.goToDatabaseMain} className="pointer db-logo">
                            <IntlMessages id={`db.${databaseCatalog.code}.code`} defaultMessage={databaseCatalog.code}/>
                        </span>
                    )
                }
            }
        }
        return '';
    }

    renderDatabaseLogo() {
        const {database} = this.state;
        return (
            <span key={'databaseLogo'} onClick={this.goToDatabaseMain}
                  className="pointer db-image">
                            {database.logo_image &&
                                <img src={`data:${database.logo_image_mime_type};base64,${database.logo_image}`}
                                     alt={""}/>}
                        </span>
        )

    }

    renderDatabaseName() {
        const {database} = this.state;
        return (
            <span key={'databaseName'} className="db-name">{database.catalog.name}</span>
        )

    }

    goToDatabaseMain() {
        const {database} = this.state;
        if (database) {
            this.props.history.push(`/app/database/${database.id}/dashboard`);
        }
    }
}

const mapStateToProps = ({settings, database, services, auth}) => {
    const authUser = auth.authUser;
    const databaseList = database.list;
    const databaseGroups = database.groups;
    const databaseEventBus = database.eventBus;
    const registryService = services.registry;
    const modalService = services.modal;
    const settingsEventBus = settings.eventBus;
    const authService = services.auth;
    return {
        databaseList,
        databaseGroups,
        registryService,
        modalService,
        settingsEventBus,
        authUser,
        authService,
        databaseEventBus
    };
};
export default withRouter(connect(mapStateToProps)(DatabaseLogo));